import React, {useContext, useEffect} from 'react'
import {observer} from "mobx-react"
import NavBar from "../Bars/NavBar/NavBar";
import * as JivoSite from 'react-jivosite'
import SideBar from "../SideBar/SideBar";
import MobileTopCircle from "./MobileTopCircle/MobileTopCircle";
import Modals from "./Modals";
import {AuthContext} from "../../context/AuthContext";




const Page = observer((props) => {
    const {roleId} = useContext(AuthContext)

    return (
        <>
            <NavBar />
            <SideBar roleId={roleId} mobile={props.mobile}/>
            <div className={`
                page 
                ${props.name} 
                ${props.mobile ? 'mobileVersion' : ''} 
                ${props.animation}`} style={props.style}>
                <MobileTopCircle/>
                {props.children}
            </div>
            <Modals/>

            <JivoSite.Widget id={process.env.jivoCode || '7FWIjBTxm6'}/>


        </>


    )
})
export default Page